// Mirrors _features/invoices/state/slice.js's shape (selectedFilters +
// customColumns, REHYDRATE normalization) - does NOT carry forward the old
// features/PlanFeature/slice.js's `plans` mirror (write-only dead-sync -
// nothing outside PlanFeature ever read state.planFeature.plans; usePlanData
// already returns straight from the RTK Query cache).
//
// Separate Redux key (`plansFeature`, plural, matching
// invoicesFeature/subscriptionsFeature/paymentsFeature) from the legacy
// singular `planFeature` key it replaces.
import { createSlice } from "@reduxjs/toolkit";
import { REHYDRATE } from "redux-persist";

const initialState = {
  selectedFilters: {
    sort: "-createdAt",
  },
};

const plansFeatureSlice = createSlice({
  name: "plansFeature",
  initialState,
  reducers: {
    updateSelectedFilters: (state, action) => {
      state.selectedFilters = action.payload;
    },
    resetSelectedFilters: (state) => {
      state.selectedFilters = {
        sort: "-createdAt",
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(REHYDRATE, (state, action) => {
      if (action.payload && action.payload.plansFeature) {
        const persistedData = action.payload.plansFeature;
        const persistedSort = persistedData.selectedFilters?.sort;

        return {
          ...state,
          ...persistedData,
          selectedFilters: {
            ...persistedData.selectedFilters,
            sort: persistedSort || "-createdAt",
          },
        };
      }
      return state;
    });
  },
});

export const { updateSelectedFilters, resetSelectedFilters } =
  plansFeatureSlice.actions;

export default plansFeatureSlice.reducer;
